/* eslint-disable no-underscore-dangle */
import stringHash from "string-hash";
import * as THREE from "three";
// import ThreejsScene from "./ThreejsScene";
import {
  ENGINE_COMPONENT_TYPES,
  ASSET_TYPES,
  XR_MODES,
  AR_PLATFORM,
} from "../constants";

import { generateUIConfig } from "./MachineHelper";
import { downloadAssets, getCorrelationData } from "./MachineUtils";

export const DYNAMIC_ANIMATION = {
  type: "dynamicAnimation",
  config: {
    name: "rotate",
    duration: 4000,
    angle: 6.283185307179586,
    delay: 1000,
  },
};

const HDR_MAP = {
  name: "HDR_CUBEMAP",
  type: "CUBE_MAP",
  exposure: 3,
  lightURL: 2573801680,
  urls: [
    "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/px.png",
    "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/nx.png",
    "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/py.png",
    "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/ny.png",
    "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/pz.png",
    "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/nz.png",
  ],
};

export const parentConfig = {
  name: "fullEmptyIcon",
  menu: [
    {
      name: "Sandy4",
      menu: [],
      icon: "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/sandy/Sandy.png",
      iconSelected:
        "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/sandy/Sandy_Selected.png",
    },
  ],
  icon: "https://d179blwxwzk8ou.cloudfront.net/common/Pepperfry_Icons_Full.png",
  iconSelected:
    "https://d179blwxwzk8ou.cloudfront.net/common/Pepperfry_Icons_Empty.png",
};

export const childButtonConfig = {
  onClick: [
    {
      type: "clipAnimation",
      config: {
        clipName: "open_with_still_70_90",
        startFrame: 0,
        endFrame: 0,
      },
    },
  ],
  onUnClick: [
    {
      type: "clipAnimation",
      config: {
        clipName: "open_without_still_205_225",
        startFrame: 0,
        endFrame: 0,
      },
    },
  ],
};
export const childButtonXXX = {
  name: "Redish",
  menu: [],
  icon: "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/red/Red.png",
  iconSelected:
    "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/red/Red_Selected.png",
};
export const childButtonConfigXXX = {
  onClick: [
    {
      type: "materials",
      config: {
        FN1599490lambert3: {
          map: 209026288,
        },
        FN1599490lambert2: {
          map: 3564914097,
        },
      },
    },
  ],
  onUnClick: [],
  default: 0,
};

export const defaultSKUConfig = {
  models: {
    path: "",
    ar: true,
    config: {
      scale: 1,
      position: [0, 0, 0],
      rotation: [0, 0, 0],
    },
  },
  camera: {
    fov: 45,
  },
  renderer: {
    antialias: true,
    colorManagement: true,
    sortObjects: true,
    physicallyCorrectLights: true,
  },
  orbitControls: {
    enableZoom: true,
    enablePan: false,
    dampingFactor: 0.01,
    enableDamping: false,
    rotateSpeed: 0.8,
    enableRotate: true,
    zoomSpeed: 0.5,
    minPolarAngle: 0,
    maxPolarAngle: 1.5707963267948966,
  },
  iconCorrelationV2: true,
  uiConfig: {
    onLoad: {
      xr: { VR_PLATFORM_THREEJS: [DYNAMIC_ANIMATION] },
      ar: {
        AR_PLATFORM_8thwall: [DYNAMIC_ANIMATION],
        AR_PLATFORM_Webxr: [DYNAMIC_ANIMATION],
      },
    },
  },
  toneMapping: {
    xr: {
      VR_PLATFORM_THREEJS: {
        enableToneMapping: true,
        type: THREE.ACESFilmicToneMapping,
        exposure: 0.75,
      },
    },
  },
  ambientLight: {
    xr: {
      VR_PLATFORM_THREEJS: {
        color: 16777215,
        intensity: 0.5,
      },
    },
    ar: {
      AR_PLATFORM_8thwall: {
        color: 16777215,
        intensity: 1,
      },
      AR_PLATFORM_Webxr: {
        color: 16777215,
        intensity: 1,
      },
    },
  },
  positionTexture: 2858241489,
  environmentLight: {
    xr: {
      VR_PLATFORM_THREEJS: { ...HDR_MAP },
    },
    ar: {
      AR_PLATFORM_8thwall: { ...HDR_MAP },
      AR_PLATFORM_Webxr: { ...HDR_MAP },
    },
  },
  directionalLights: {
    xr: {
      VR_PLATFORM_THREEJS: [
        {
          color: "#FFF",
          intensity: 3,
          position: [-1.5, 4, 4],
          castShadow: true,
          "shadow-mapSize-height": 2048,
          "shadow-mapSize-width": 2048,
          "shadow-camera-top": 10,
          customId: "43a30430-4d1d-11ec-9beb-510fb6cb1778",
        },
      ],
    },
    ar: {
      AR_PLATFORM_8thwall: [
        {
          color: "#FFF",
          intensity: 2.5,
          position: [0, 4, 0],
          castShadow: true,
          "shadow-mapSize-height": 2048,
          "shadow-mapSize-width": 2048,
          "shadow-camera-top": 10,
          customId: "43a30430-4d1d-11ec-9beb-510fb6cb1778",
        },
      ],
      AR_PLATFORM_Webxr: [
        {
          color: "#FFF",
          intensity: 2.5,
          position: [0, 4, 0],
          castShadow: true,
          "shadow-mapSize-height": 2048,
          "shadow-mapSize-width": 2048,
          "shadow-camera-top": 10,
          customId: "43a30430-4d1d-11ec-9beb-510fb6cb1778",
        },
      ],
    },
  },
  assets: {
    // 1000799432: {
    //   type: "CUBE_MAP",
    //   url: "https://d179blwxwzk8ou.cloudfront.net/cubemap/",
    //   urls: [
    //     "https://d179blwxwzk8ou.cloudfront.net/cubemap/posx.png",
    //     "https://d179blwxwzk8ou.cloudfront.net/cubemap/negx.png",
    //     "https://d179blwxwzk8ou.cloudfront.net/cubemap/posy.png",
    //     "https://d179blwxwzk8ou.cloudfront.net/cubemap/negy.png",
    //     "https://d179blwxwzk8ou.cloudfront.net/cubemap/posz.png",
    //     "https://d179blwxwzk8ou.cloudfront.net/cubemap/negz.png",
    //   ],
    // },
    2858241489: {
      type: "TEXTURE",
      url: "https://web2.avataar.me/common/ar_floor_placement_grid.png",
    },
    2573801680: {
      type: "CUBE_MAP",
      url: "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/",
      urls: [
        "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/px.png",
        "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/nx.png",
        "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/py.png",
        "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/ny.png",
        "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/pz.png",
        "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/nz.png",
      ],
    },
  },
};

export const getDefaultClipAnimationConfig = (clipName) => {
  return {
    clipName,
  };
};

export const getClipAnimationNames = (actions, modelId) => {
  return () => {
    const modelsObject = actions.ARModels.getModel(modelId);
    console.log("getClipAnimationNames", modelsObject);
    return modelsObject.animations.map((clipAnimation) => clipAnimation.name);
  };
};

export const getMaterialNames = (actions, modelId) => {
  return () => {
    const modelsObject = actions.ARModels.getModel(modelId);
    console.log("get material names", modelsObject);
    return Object.keys(modelsObject.materials);
  };
};

export const applyTexture = (actions, modelId, skuId) => {
  return async (materialName, materialConfig) => {
    console.log("engineutils, applytexture", materialName, materialConfig);
    const asssetMetaObject = {};
    Object.keys(materialConfig).forEach((mapName) => {
      if (
        mapName.toLocaleLowerCase().includes("map") &&
        materialConfig[mapName].toString().startsWith("http")
      ) {
        const hashed = stringHash(materialConfig[mapName]);
        asssetMetaObject[hashed] = {
          type: ASSET_TYPES.TEXTURE,
          url: materialConfig[mapName],
        };
        materialConfig[mapName] = hashed;
        actions.ConfigBuilder.addAsset(skuId, hashed, asssetMetaObject[hashed]);
      }
    });
    await actions.AssetLoader.loadAllAssets(asssetMetaObject);
    actions.ARModels.applyMaterial(
      modelId,
      materialName,
      materialConfig,
      actions.AssetLoader.getAsset
    );
  };
};

export const triggerAssetDownloadIfAny = async (
  actions,
  assetConfig,
  skuId
) => {
  console.log("triggerAssetDownloadIfAny", assetConfig, skuId);
  const asssetMetaObject = {};
  const { lightURL } = assetConfig;
  let hashed = lightURL;
  if (typeof lightURL === "string" && lightURL.toString().startsWith("http")) {
    hashed = stringHash(lightURL);
    asssetMetaObject[hashed] = {
      type: assetConfig.type,
      url: lightURL,
      urls: assetConfig.urls,
    };
    actions.ConfigBuilder.addAsset(skuId, hashed, asssetMetaObject[hashed]);
  }

  await actions.AssetLoader.loadAllAssets(asssetMetaObject);
  return hashed;
};

export const highlightMaterial = (actions, modelId) => {
  return (materialName) => {
    const currentColor =
      actions.ARModels.getModel(modelId).materials[materialName].color.getHex();
    console.log("model colorXXX", currentColor);
    actions.ARModels.getModel(modelId).materials[materialName].color.set(
      0xff0000
    );
    setTimeout(() => {
      actions.ARModels.getModel(modelId).materials[materialName].color.set(
        currentColor
      );
    }, 500);
  };
};
// const updateUIConfig = (
//   actions,
//   modelId,
//   skuId,
//   heirarchy,
//   submenuConfig,
//   jsonConfig
// ) => {
//   console.log(
//     "updateUIConfig",
//     skuId,
//     heirarchy,
//     submenuConfig,
//     modelId,
//     jsonConfig.uiConfig
//   );
//   let uiconfig = submenuConfig;
//   let buttonConfig = jsonConfig.uiConfig;
//   for (let i = 0; i < heirarchy.length; i += 1) {
//     if (!uiconfig) break;
//     uiconfig = uiconfig.menu.find((e) => e.name === heirarchy[i]);
//     buttonConfig = buttonConfig.menu.find((e) => e.name === heirarchy[i]);
//   }
//   if (uiconfig) {
//     uiconfig.onClick = replaceWithCallback(
//       actions,
//       buttonConfig.onClick,
//       modelId
//     );
//     uiconfig.onUnClick = replaceWithCallback(
//       actions,
//       buttonConfig.onUnClick,
//       modelId
//     );
//     console.log("submenu config updated", uiconfig);
//   }
// };

export const addButtonConfigs = (
  skuId,
  actions,
  modelId,
  heirarchy,
  isButton
) => {
  return (config) => {
    if (isButton) {
      console.log("addButtonActions add button", config);
      actions.ConfigBuilder.addButton(skuId, config, heirarchy);
    } else {
      console.log("addButtonActions add addButtonActions", config);
      actions.ConfigBuilder.addButtonActions(skuId, config, heirarchy);
      // updateUIConfig(
      //   actions,
      //   modelId,
      //   skuId,
      //   heirarchy,
      //   actions.useSubmenuStore.getState().buttonsConfig,
      //   actions.ConfigBuilder.getSKUConfig(skuId)
      // );
      downloadAssets(actions, skuId, false)();
    }

    const buttonsConfig = generateUIConfig(
      modelId,
      actions,
      actions.ConfigBuilder.getSKUConfig(skuId),
      XR_MODES.XR,
      AR_PLATFORM.THREEJS,
      "ENGINE"
    );
    console.log("ThreeDInteractivityTab setting buttonsConfig", buttonsConfig);
    actions.useSubmenuStore.getState().setButtonsConfig(buttonsConfig);
    actions.useSubmenuStore
      .getState()
      .setCorrelationConfig(getCorrelationData(buttonsConfig));
  };
};

export const removeButton = (skuId, actions, modelId, heirarchy) => {
  return (buttonName) => {
    actions.ConfigBuilder.removeButton(skuId, buttonName, heirarchy);
    const buttonsConfig = generateUIConfig(
      modelId,
      actions,
      actions.ConfigBuilder.getSKUConfig(skuId),
      XR_MODES.XR,
      AR_PLATFORM.THREEJS,
      "ENGINE"
    );
    console.log("ThreeDInteractivityTab setting buttonsConfig", buttonsConfig);
    actions.useSubmenuStore.getState().setButtonsConfig(buttonsConfig);
  };
};

export const updateDefaultButton = (skuId, actions, modelId, heirarchy) => {
  return (buttonName) => {
    actions.ConfigBuilder.updateDefaultButton(skuId, buttonName, heirarchy);
    const buttonsConfig = generateUIConfig(
      modelId,
      actions,
      actions.ConfigBuilder.getSKUConfig(skuId),
      XR_MODES.XR,
      AR_PLATFORM.THREEJS,
      "ENGINE"
    );
    console.log("ThreeDInteractivityTab setting buttonsConfig", buttonsConfig);
    actions.useSubmenuStore.getState().setButtonsConfig(buttonsConfig);
  };
};

export const setInteractivePage = (
  actions,
  context,
  templateButtonConfigs,
  topLevelButtonsPresets
) => {
  const { skuId, modelId } = context;
  return (...heirarchy) => {
    console.log("calling setinteractivepage", heirarchy, templateButtonConfigs);
    const errorMessage = null;
    const skuConfig = actions.ConfigBuilder.getSKUConfig(skuId);
    let attachedConfig = skuConfig.uiConfig ?? defaultSKUConfig.uiConfig;
    console.log(
      "🚀 ~ file: EngineUtils.js ~ line 286 ~ return ~ skuConfig",
      skuConfig
    );
    for (let i = 0; i < heirarchy.length; i += 1) {
      if (attachedConfig == null) {
        console.log("error in parsing config");
        break;
      }
      attachedConfig = attachedConfig.menu.find(
        (buttonConfig) => buttonConfig.name === heirarchy[i]
      );
    }
    let templateConfig = null;
    let homeTemplateConfig = null;
    homeTemplateConfig = {
      getOptions: () => topLevelButtonsPresets,
      actions: {
        onLoad: [
          ENGINE_COMPONENT_TYPES.MATERIALS_COMPONENT,
          ENGINE_COMPONENT_TYPES.OPACITY_COMPONENT,
          ENGINE_COMPONENT_TYPES.CLIP_ANIMATION_COMPONENT,
        ],
        onSlot: [ENGINE_COMPONENT_TYPES.ADD_SLOTS],
      },
      meta: "HOME",
    };
    if (heirarchy.length === 0) {
      templateConfig = homeTemplateConfig;
    } else {
      templateConfig = templateButtonConfigs;
      for (let i = 0; i < heirarchy.length; i += 1) {
        if (i === 0)
          templateConfig = templateConfig.find((e) => e.name === heirarchy[i]);
        else {
          templateConfig = templateConfig.children;
        }
      }
    }

    const individualConfig = {
      heirarchy,
      attachedConfig,
      templateConfig,
      errorMessage,
      addButtonConfig: addButtonConfigs(
        skuId,
        actions,
        modelId,
        heirarchy,
        false
      ),
      addButton: addButtonConfigs(skuId, actions, modelId, heirarchy, true),
      updateDefaultButton: updateDefaultButton(
        skuId,
        actions,
        modelId,
        heirarchy
      ),
      removeButton: removeButton(skuId, actions, modelId, heirarchy),
      getClipNames: getClipAnimationNames(actions, modelId),
      getMaterialNames: getMaterialNames(actions, modelId),
      applyTexture: applyTexture(actions, modelId, skuId),
      applyOpacity: applyTexture(actions, modelId, skuId),
      playAnimation: (clipName) =>
        actions.ARModels.playClipAnimation(
          modelId,
          getDefaultClipAnimationConfig(clipName)
        ),
      highlightMaterial: highlightMaterial(actions, modelId),
      setInteractivePage: setInteractivePage(
        actions,
        context,
        templateButtonConfigs,
        topLevelButtonsPresets
      ),
      getAssetUrl: actions.AssetLoader.getURLFromAssetId,
      getContextData: () => context,
    };
    console.log("getIndividualConfig", individualConfig);
    actions.useEngineStore.getState().setinteractiveConfig(individualConfig);
    return individualConfig;
  };
};
